<template>
	<div class="content my-0 py-1">
		<div class="container-fluid">
			<div class="row">

				<div class="col-12 w-100 my-3">
					<ul class="nav nav-tabs">
						<li class="nav-item">
							<button class="nav-link" :class="[selectedTab==0?'active':'']" href="#"
							        v-on:click="selectedTab=0">Perpanjangan Airtime
							</button>
						</li>
						<li class="nav-item">
							<button class="nav-link" :class="[selectedTab==1?'active':'']" href="#"
							        v-on:click="selectedTab=1">Airtime Baru
							</button>
						</li>
					</ul>


					<div class="col-12 w-100 my-3" v-if="selectedTab==0">
						<ul class="nav nav-tabs">
							<li class="nav-item">
								<button class="nav-link" :class="[selectedTabRenewal==0]" href="#"
								        v-on:click="getData(0)">Beranda
								</button>
							</li>
							<li class="nav-item">
								<button class="nav-link" :class="[selectedTabRenewal==1]" href="#"
								        v-on:click="getData(1)">3 bulan
								</button>
							</li>
							<li class="nav-item">
								<button class="nav-link" :class="[selectedTabRenewal==2]" href="#"
								        v-on:click="getData(2)">2 bulan
								</button>
							</li>
							<li class="nav-item">
								<button class="nav-link" :class="[selectedTabRenewal==3]" href="#"
								        v-on:click="getData(3)">1 bulan
								</button>
							</li>
							<li class="nav-item">
								<button class="nav-link" :class="[selectedTabRenewal==4]" href="#"
								        v-on:click="getData(4)">1 bulan masa tenggang
								</button>
							</li>
							<li class="nav-item">
								<button class="nav-link" :class="[selectedTabRenewal==5]" href="#"
								        v-on:click="getData(5)">Tidak aktif
								</button>
							</li>
						</ul>

						<div class="col-12  my-2 py-0">
							<h4 class="text-secondary">Perpanjangan airtime</h4>
							<datatable :lang="dicts.lang" :datas="RenewalAirtimes"
							           :structure="RenewalAirtimeTableStructure" :init="loadData" use-seeker
							           seeker-url="/api/pemesanan/pengingat/from/airtime"
							           @searching="searchResultRenewalAirtime">
								<template #customcell={obj,index}>
									<td class="border-0" :class="colorPeriod(obj.due_in_day)">{{ index + 1 }}</td>
									<td class="border-0" :class="colorPeriod(obj.due_in_day)">{{
											obj.invoice_item_metadata ? obj.invoice_item_metadata.order_metadata.hardware_setup.vessel.name : "-"
										}}
									</td>
									<td class="border-0" :class="colorPeriod(obj.due_in_day)">{{
											obj.invoice_item_metadata ? obj.invoice_item_metadata.order_metadata.hardware_setup.id_transmitter : "-"
										}}
									</td>
									<td class="border-0" :class="colorPeriod(obj.due_in_day)">
										{{
											obj.invoice_item_metadata ? obj.invoice_item_metadata.order_metadata.hardware_setup.vessel.client.legal_name : "-"
										}}
									</td>
									<td class="border-0" :class="colorPeriod(obj.due_in_day)">
										{{ obj.start_period | timeformat }}
									</td>
									<td class="border-0" :class="colorPeriod(obj.due_in_day)">
										{{ obj.finish_date | timeformat }}
									</td>
									<td class="border-0" :class="colorPeriod(obj.due_in_day)">
										{{ obj.expected_reminder | timeformat }}
									</td>
									<td class="border-0" :class="colorPeriod(obj.due_in_day)">
										{{
											obj.invoice_item_metadata ? obj.invoice_item_metadata.order_metadata.hardware_setup.vessel.client.telephone_pemilik : "-"
										}}
									</td>
									<td class="border-0" :class="colorPeriod(obj.due_in_day)">
										<b-button v-b-modal.modal-detail-renewal-airtime
										          class="btn bg-white btn-primary mr-2 mb-1"
										          v-on:click="selectedDetailRenewalAirtime=index">
											<b-icon icon="eye"></b-icon>
										</b-button>
									</td>
								</template>
							</datatable>
						</div>

					</div>

					<div class="col-12 w-100 my-3" v-if="selectedTab==1">
						<ul class="nav nav-tabs">
							<li class="nav-item">
								<button class="nav-link" :class="[selectedTabNew==0]" href="#"
								        v-on:click="getDataNewAirtimes(0)">Beranda
								</button>
							</li>
							<li class="nav-item">
								<button class="nav-link" :class="[selectedTabNew==1]" href="#"
								        v-on:click="getDataNewAirtimes(1)">3 bulan
								</button>
							</li>
							<li class="nav-item">
								<button class="nav-link" :class="[selectedTabNew==2]" href="#"
								        v-on:click="getDataNewAirtimes(2)">2 bulan
								</button>
							</li>
							<li class="nav-item">
								<button class="nav-link" :class="[selectedTabNew==3]" href="#"
								        v-on:click="getDataNewAirtimes(3)">1 bulan
								</button>
							</li>
							<li class="nav-item">
								<button class="nav-link" :class="[selectedTabNew==4]" href="#"
								        v-on:click="getDataNewAirtimes(4)">1 bulan masa tenggang
								</button>
							</li>
							<li class="nav-item">
								<button class="nav-link" :class="[selectedTabNew==5]" href="#"
								        v-on:click="getDataNewAirtimes(5)">Tidak aktif
								</button>
							</li>
						</ul>

						<div class="col-12  my-2 py-0" v-if="selectedTabNew==0">
							<h4 class="text-secondary">Airtime baru</h4>
							<datatable :lang="dicts.lang" :datas="NewAirtimes" :structure="RenewalAirtimeTableStructure"
							           :init="loadDataItem" :next-url="nextUrl" :prev-url="prevUrl"
							           @change-page="(isNext)=>{changePage(isNext)}" use-seeker
							           seeker-url="/api/pemesanan/pengingat/from/item"
							           @searching="searchResultNewAirtime">
								<template #customcell={obj,index}>
									<td class="border-0" :class="colorPeriod(obj.due_in_day)">{{ index + 1 }}</td>
									<td class="border-0" :class="colorPeriod(obj.due_in_day)">{{
											obj.invoice_item_metadata ? obj.invoice_item_metadata.order_metadata.hardware_setup.vessel.name : "-"
										}}
									</td>
									<td class="border-0" :class="colorPeriod(obj.due_in_day)">{{
											obj.invoice_item_metadata ? obj.invoice_item_metadata.order_metadata.hardware_setup.id_transmitter : "-"
										}}
									</td>
									<td class="border-0" :class="colorPeriod(obj.due_in_day)">
										{{
											obj.invoice_item_metadata ? obj.invoice_item_metadata.order_metadata.hardware_setup.vessel.client.legal_name : "-"
										}}
									</td>
									<td class="border-0" :class="colorPeriod(obj.due_in_day)">
										{{ obj.start_period | timeformat }}
									</td>
									<td class="border-0" :class="colorPeriod(obj.due_in_day)">
										{{ obj.finish_date | timeformat }}
									</td>
									<td class="border-0" :class="colorPeriod(obj.due_in_day)">
										{{ obj.expected_reminder | timeformat }}
									</td>
									<td class="border-0" :class="colorPeriod(obj.due_in_day)">
										{{
											obj.invoice_item_metadata ? obj.invoice_item_metadata.order_metadata.hardware_setup.vessel.client.telephone_pemilik : "-"
										}}
									</td>
									<td class="border-0" :class="colorPeriod(obj.due_in_day)">
										<b-button v-b-modal.modal-detail-new-airtime
										          class="btn bg-white btn-primary mr-2 mb-1"
										          v-on:click="selectedDetail=index">
											<b-icon icon="eye"></b-icon>
										</b-button>
									</td>
								</template>
							</datatable>
						</div>

					</div>

					<b-modal no-close-on-esc content-class="m-0" title="Detail Perpanjangan Airtime"
					         id="modal-detail-renewal-airtime" scrollable no-close-on-backdrop>
						<b-container fluid v-if="!loadData&&RenewalAirtimes.length>0">
							<b-row class="pt-1" v-if="RenewalAirtimes[selectedDetailRenewalAirtime]!=undefined">
								<b-col cols="12">
									<table v-if="RenewalAirtimes.length>0" rules="rows" class="table w-100"
									       style="overflow-x:auto;">
										<tbody>
										<tr>
											<th class="w-100 px-3 bg-secondary text-white" style="font-size:14pt"
											    colspan="2" scope="row">Detail Perpanjangan Airtime
											</th>
										</tr>
										<tr>
											<th class="" scope="row">Nomor SN</th>
											<td class="">
												{{
													RenewalAirtimes[selectedDetailRenewalAirtime].invoice_item_metadata.order_metadata.hardware_setup.serial_number.serial_number
												}}
											</td>
										</tr>
										<tr>
											<th class="" scope="row">ID transmitter</th>
											<td class="">
												{{
													RenewalAirtimes[selectedDetailRenewalAirtime].invoice_item_metadata.order_metadata.hardware_setup.id_transmitter
												}}
											</td>
										</tr>
										<tr>
											<th class="" scope="row">Nomor JB</th>
											<td class="">{{
													RenewalAirtimes[selectedDetailRenewalAirtime].invoice_item_metadata.order_metadata.hardware_setup.jb
														? RenewalAirtimes[selectedDetailRenewalAirtime].invoice_item_metadata.order_metadata.hardware_setup.jb.serial_number
														: "-"
												}}
											</td>
										</tr>
										<tr>
											<th class="" scope="row">Nama kapal</th>
											<td class="">
												{{
													RenewalAirtimes[selectedDetailRenewalAirtime].invoice_item_metadata.order_metadata.hardware_setup.vessel.name
												}}
											</td>
										</tr>
										<tr>
											<th class="" scope="row">Pelanggan</th>
											<td class="">
												{{
													RenewalAirtimes[selectedDetailRenewalAirtime].invoice_item_metadata.order_metadata.hardware_setup.vessel.client.legal_name
												}}
											</td>
										</tr>
										<tr>
											<th class="" scope="row">Tanggal aktivasi</th>
											<td class="">
												{{
													RenewalAirtimes[selectedDetailRenewalAirtime].start_period | timeformat
												}}
											</td>
										</tr>
										<tr>
											<th class="" scope="row">Jatuh tempo</th>
											<td class="">
												{{
													RenewalAirtimes[selectedDetailRenewalAirtime].finish_date | timeformat
												}}
											</td>
										</tr>
										<tr>
											<th class="" scope="row">Tanggal penagihan</th>
											<td class="">
												{{
													RenewalAirtimes[selectedDetailRenewalAirtime].expected_reminder | timeformat
												}}
											</td>
										</tr>

										</tbody>

									</table>
								</b-col>
							</b-row>
						</b-container>
						<template #modal-footer>
							<div class="w-100 text-right m-0 p-0">
								<hr>
								<b-button class="btn btn-secondary"
								          @click="!$bvModal.hide('modal-detail-renewal-airtime')">Tutup
								</b-button>
							</div>
						</template>
					</b-modal>


				</div>

				<b-modal no-close-on-esc content-class="m-0" title="Detail airtime baru" id="modal-detail-new-airtime"
				         scrollable no-close-on-backdrop>
					<b-container fluid v-if="!loadDataItem&&NewAirtimes.length>0">
						<b-row class="pt-1" v-if="NewAirtimes[selectedDetail]!=undefined">
							<b-col cols="12">
								<table v-if="NewAirtimes.length>0" rules="rows" class="table w-100"
								       style="overflow-x:auto;">
									<tbody>
									<tr>
										<th class="w-100 px-3 bg-secondary text-white" style="font-size:14pt"
										    colspan="2" scope="row">Detail airtime baru
										</th>
									</tr>
									<tr>
										<th class="" scope="row">Nomor SN</th>
										<td class="">
											{{
												NewAirtimes[selectedDetail].invoice_item_metadata.order_metadata.hardware_setup.serial_number.serial_number
											}}
										</td>
									</tr>
									<tr>
										<th class="" scope="row">ID transmitter</th>
										<td class="">
											{{
												NewAirtimes[selectedDetail].invoice_item_metadata.order_metadata.hardware_setup.id_transmitter
											}}
										</td>
									</tr>
									<tr>
										<th class="" scope="row">Nomor JB</th>
										<td class="">
											{{
												NewAirtimes[selectedDetail].invoice_item_metadata.order_metadata.hardware_setup.jb
													? NewAirtimes[selectedDetail].invoice_item_metadata.order_metadata.hardware_setup.jb.serial_number
													: "-"
											}}
										</td>
									</tr>
									<tr>
										<th class="" scope="row">Nama kapal</th>
										<td class="">
											{{
												NewAirtimes[selectedDetail].invoice_item_metadata.order_metadata.hardware_setup.vessel.name
											}}
										</td>
									</tr>
									<tr>
										<th class="" scope="row">Pelanggan</th>
										<td class="">
											{{
												NewAirtimes[selectedDetail].invoice_item_metadata.order_metadata.hardware_setup.vessel.client.legal_name
											}}
										</td>
									</tr>
									<tr>
										<th class="" scope="row">Tanggal aktivasi</th>
										<td class="">{{ NewAirtimes[selectedDetail].start_period | timeformat }}</td>
									</tr>
									<tr>
										<th class="" scope="row">Jatuh tempo</th>
										<td class="">{{ NewAirtimes[selectedDetail].finish_date | timeformat }}</td>
									</tr>
									<tr>
										<th class="" scope="row">Tanggal penagihan</th>
										<td class="">{{ NewAirtimes[selectedDetail].expected_reminder | timeformat }}
										</td>
									</tr>

									</tbody>

								</table>
							</b-col>
						</b-row>
					</b-container>
					<template #modal-footer>
						<div class="w-100 text-right m-0 p-0">
							<hr>
							<b-button class="btn btn-secondary" @click="!$bvModal.hide('modal-detail-new-airtime')">
								Tutup
							</b-button>
						</div>
					</template>
				</b-modal>


			</div>
		</div>
	</div>
</template>
<script>
//   import ChartCard from 'src/components/Cards/ChartCard.vue'
//   import StatsCard from 'src/components/Cards/StatsCard.vue'
//   import LTable from 'src/components/Table.vue'
import {EventBus} from "../../eventbus";
import * as axios from "axios";
import Datatable from "../../components/Datatable.vue";

export default {
	components: {
		//   LTable,
		//   ChartCard,
		//   StatsCard
		"datatable": Datatable
	},
	data() {
		return {
			nextUrl: null,
			prevUrl: null,
			selectedDetailRenewalAirtime: 0,
			selectedDetail: 0,
			selectedTab: 0,
			selectedTabRenewal: 0,
			selectedTabNew: 0,
			loadData: true,
			loadDataItem: true,
			isMobile: false,
			RenewalAirtimes: [],
			NewAirtimes: [],
			searchValue: "",
			RenewalAirtimeTableStructure: [
				{label: "No", key: null},
				{
					label: {
						id: "Nama kapal",
						en: "Vessel name"
					},
					key: null
				},
				{label: "ID transmitter", key: null},
				{
					label: {
						id: "Pelanggan",
						en: "Client"
					},
					key: null
				},
				{
					label: {
						id: "Tanggal aktivasi",
						en: "Activation date"
					},
					key: null
				},
				{
					label: {
						id: "Jatuh tempo",
						en: "Due date"
					},
					key: null
				},
				{
					label: {
						id: "Tanggal penagihan",
						en: "Billing date"
					},
					key: null
				},
				{
					label: {
						id: "Telp pelanggan",
						en: "Telp client"
					},
					key: null
				},
				{
					label: {
						id: "Tindakan",
						en: "Action"
					},
					key: null
				}
			],
			dicts: {
				lang: "id",
				page_title: {
					id: "Invoice perangkat",
					en: "Invoice item"
				}
			}
		};
	},
	created() {
		this.$reActivateAccess(this); /*SETTIMEOUT LOGOUT OTOMATIS, (this,true) UTK MELIHAT DETIK DI BROWSHER*/
		this.getRenewalAirtimes();
		this.getNewAirtimes();
		this.dicts.lang = localStorage.getItem("lang");
		EventBus.$on("lang", () => {
			console.log("changing invoice item lang");
			this.dicts.lang = localStorage.getItem("lang");
		});
	},
	methods: {
		searchResultRenewalAirtime(val) {
			console.clear();
			console.log(val);
			if (val.status && val.data.data.length > 0) {
				this.RenewalAirtimes = val.data.data;
			} else {
				this.getRenewalAirtimes();
			}
		},
		searchResultNewAirtime(val) {
			console.clear();
			console.log(val);
			if (val.status && val.data.data.length > 0) {
				this.NewAirtimes = val.data.data;
			} else {
				this.getNewAirtimes();
			}
		},
		getData(state) {
			if (state == 0) {
				this.getRenewalAirtimes();
			} else if (state == 1) {
				this.getRenewalAirtimes(this.$baseUrl + "/api/pemesanan/pengingat/from/airtime?status=3month");
			} else if (state == 2) {
				this.getRenewalAirtimes(this.$baseUrl + "/api/pemesanan/pengingat/from/airtime?status=2month");
			} else if (state == 3) {
				this.getRenewalAirtimes(this.$baseUrl + "/api/pemesanan/pengingat/from/airtime?status=1month");
			} else if (state == 4) {
				this.getRenewalAirtimes(this.$baseUrl + "/api/pemesanan/pengingat/from/airtime?status=over1month");
			} else if (state == 5) {
				this.getRenewalAirtimes(this.$baseUrl + "/api/pemesanan/pengingat/from/airtime?status=over2month");
			}
		},
		getDataNewAirtimes(state) {
			if (state == 0) {
				this.getNewAirtimes();
			} else if (state == 1) {
				this.getNewAirtimes(this.$baseUrl + "/api/pemesanan/pengingat/from/item?status=3month");
			} else if (state == 2) {
				this.getNewAirtimes(this.$baseUrl + "/api/pemesanan/pengingat/from/item?status=2month");
			} else if (state == 3) {
				this.getNewAirtimes(this.$baseUrl + "/api/pemesanan/pengingat/from/item?status=1month");
			} else if (state == 4) {
				this.getNewAirtimes(this.$baseUrl + "/api/pemesanan/pengingat/from/item?status=over1month");
			} else if (state == 5) {
				this.getNewAirtimes(this.$baseUrl + "/api/pemesanan/pengingat/from/item?status=over2month");
			}
		},
		colorPeriod(period) {
			if (period < -30) {
				return "bg-black";
			}
			if (period >= -30 && period < 0) {
				return "bg-grey";
			}
			if (period >= 0 && period <= 29) {
				return "bg-red";
			}
			if (period > 30 && period <= 59) {
				return "bg-yellow";
			}
			if (period > 60 && period <= 90) {
				return "bg-green";
			}
		},
		getRenewalAirtimes(url = (this.$baseUrl + "/api/pemesanan/pengingat/from/airtime")) {
			this.loadData = true;
			axios.get(url, {
				"headers": {
					"Authorization": "Bearer " + localStorage.getItem("accessToken")
				}
			}).then((result) => {
				console.log(result);
				this.prevUrl = result.data.prev_page_url;
				this.nextUrl = result.data.next_page_url;
				this.RenewalAirtimes = result.data.data;
				this.loadData = false;
			}).catch((err) => {
				//check if token fail
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				console.log(err);
				this.loadData = false;
			});
		},
		getNewAirtimes(url = (this.$baseUrl + "/api/pemesanan/pengingat/from/item")) {
			this.loadDataItem = true;
			axios.get(url, {
				"headers": {
					"Authorization": "Bearer " + localStorage.getItem("accessToken")
				}
			}).then((result) => {
				console.log(result);
				this.NewAirtimes = result.data.data;
				this.loadDataItem = false;
			}).catch((err) => {
				//check if token fail
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				console.log(err);
				this.loadDataItem = false;
			});
		}

	}
};
</script>
<style scoped>
.btn {
	padding: 2px 6px;
}

.nav .nav-item .nav-link:hover, .nav .nav-item .nav-link:focus {
	background-color: #fff;
}

.table > thead > tr > th, .table > tbody > tr > th, .table > tfoot > tr > th, .table > thead > tr > td, .table > tbody > tr > td, .table > tfoot > tr > td {
	width: 50%;
}

::v-deep .modal.show .modal-dialog {
	transform: translate(0px, 10%);
}

::v-deep .modal-dialog-scrollable .modal-content {
	max-height: calc(100vh - 7.5rem);
}
</style>
